
import { useEffect, useState } from 'react';
import { Email_VALIDATOR, ERRORS, NAME_VALIDATOR, PRIVACY_URL, URL_VALIDATOR, TERMS_URL } from '../../constants/AppConstants';
import {  useMutation } from 'react-query';
import registerUser from '../../services/signUpService';
import { toast } from 'react-toastify'
import { useHistory } from 'react-router';
import PreLoginBanner from '../../components/PreloginBanner';
import LogoContainer from '../../components/LogoContainer';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumber from 'libphonenumber-js'
import Loader from '../../components/Loader/loader';
import { useAppContext } from '../../appProvider/contextProvider';
import ChirpyWeb from '../../assets/icons/poweredByChirpy.svg'

const SignUp = () => {

    const history = useHistory();
    

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [country_code, setCountryCode] = useState('');
    const [rawPhoneNumber, setRawPhoneNumber] = useState('');
    const [phone, setPhoneNumber] = useState('');
    const [website, setWebsite] = useState('');

    const [nameError, setNameError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [passwordError, setPasswordError] = useState(null);
    const [confirmPasswordError, setConfirmPasswordError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [websiteError, setWebsiteError] = useState(null);

    const {isFetching, isMutating} = useAppContext();

    const [viewPassword, setViewPassword] = useState(false);
    const [viewConfirmPassword, setViewConfirmPassword] = useState(false);

    useEffect(() => {
        const url = new URL(window.location.href);
        const email = url.searchParams.get('email');
        if(email) {
            handelEmailValidation(email);
        }
        const websiteUrl = url.searchParams.get('websiteUrl');
        if(websiteUrl) {
            handelWebsiteValidation(websiteUrl);
        }
    }, [])

    const handelNameValidation = (value) => {
        if(value.trim().length <= 0 ) {
            setNameError(ERRORS.NAME_REQUIRED);
        } else if(value.length > 30 ){
            setNameError(ERRORS.NAME_MAX_LENGTH);
        }
        else if(!value.match(NAME_VALIDATOR)) {
            setNameError(ERRORS.IN_VALID_NAME);
        } else {
            setNameError(null);
        }
        setName(value)
    }

    const handelEmailValidation = (value) => {
        if(value.trim().length <= 0 ) {
            setEmailError(ERRORS.EMAIL_REQUIRED);
        }else if(value.length > 255){
            setEmailError(ERRORS.EMAIL_LENGTH);
        }
        else if(!value.match(Email_VALIDATOR)) {
            setEmailError(ERRORS.IN_VALID_EMAIL);
        } else {
            setEmailError(null);
        }
        setEmail(value)
    }

    const handelPhoneNumberChange = (value, data, event, formattedValue) => {
        setCountryCode(`+${data.dialCode}`)
        setPhoneNumber(value.slice(data.dialCode.length));
        setRawPhoneNumber(formattedValue);
    }

    const handelPhoneNumberValidator = (value, data, event, formattedValue) => {
        const phone = parsePhoneNumber(rawPhoneNumber);
        if(phone && !phone.isValid()) {
           setPhoneError(ERRORS.IN_VALID_PHONE_NUMBER); 
        } else if(!phone) {
            setPhoneError(ERRORS.PHONE_NUMBER_REQUIRED);
        } else {
            setPhoneError(null);
        }
    }

    const handelPasswordValidation = (value) => {
        if(value.trim().length <= 0 ) {
            setPasswordError(ERRORS.PASSWORD_REQUIRED);
        } else if(value.length > 0 && value.length < 8) {
            setPasswordError(ERRORS.PASSWORD_LENGTH);            
        } else if(value.length > 30) {
            setPasswordError(ERRORS.PASSWORD_MAX_LENGTH);
            
        } else if(value !== confirm_password) {
            setPasswordError(null);
            setConfirmPasswordError(ERRORS.PASSWORD_MATCH_ERROR);
        } else if(value === confirm_password) {
            setConfirmPasswordError(null);
        }else {
            setPasswordError(null);
        }
        setPassword(value)
    }

    const handelConfirmPasswordValidation = (value) => {
        if(value.trim().length <= 0 ) {
            setConfirmPasswordError(ERRORS.PASSWORD_REQUIRED);
        }
        else if(value !== password ) {
            setConfirmPasswordError(ERRORS.PASSWORD_MATCH_ERROR);
        }
        else {
            setConfirmPasswordError(null);
        }
        setConfirmPassword(value)       
    }       

    const handelWebsiteValidation =      (value) => {
        if(value.trim().length <= 0) {
            setWebsiteError(ERRORS.WEBSITE_URL_REQUIRED);
        }
        else if(!value.toLowerCase().startsWith('https://')) {
            setWebsiteError(ERRORS.WEBSITE_HTTPS_REQUIRED);
        }
        else if(!value.toLowerCase().match(URL_VALIDATOR)) {
            setWebsiteError(ERRORS.WEBSITE_URL_VALID);
        } else {
            setWebsiteError(null);
        }
        setWebsite(value)
    }
    
    const isRegisterDisabled = () => {
        return name.length <= 0 || email.length <= 0 || password.length <= 0 || phone.length <= 0  || website.length <= 0 
        || confirm_password.length <= 0 || emailError || passwordError || nameError || confirmPasswordError
        || phoneError || websiteError;
    }

    const register = useMutation((event) => {
        event.preventDefault();
        return registerUser({name, email, password, confirm_password, website, country_code, phone});
    }, {
        onSuccess: ((userData) => {
            if(userData.errors) {
                handelError(userData.errors);
            } else {
                window.open('https://chirpyweb.com/thank-you-for-signing-up/', '_self');
                reset();
            }
        }),
        onError: ((error) => {
            toast.error(error.message,  {
                autoClose: 5000,
                position: 'bottom-right'
            });
        })
    });

    const reset = () => {
        setName('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setWebsite('');
        setNameError(null);
        setEmailError(null);
        setPasswordError(null);
        setConfirmPasswordError(null);
        setWebsiteError(null);
    }


    const handelError = (error) => {
        if(error.email) {
            toast.error(ERRORS[error.email[0]],  {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
        else if(error.website) {
            toast.error(ERRORS[error.website[0]],  {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
    }

    return  <>
    <div className={!!(isMutating || isFetching) ? 'row no-gutters page-container loader full-height p-0':  'row no-gutters full-height'}>
        {!!(isMutating || isFetching) && <Loader />}
    <div className="col col-12 col-lg-6 full-height scrollable_y">
        <div className="login-container d-flex flex-column justify-content-center full-height">                
            <LogoContainer src={ChirpyWeb} />   
            <h3 className="text-primary mb-2">Sign Up</h3>
            <p className="text-light mb-4">Send Notifications and Track your engagement!</p>
            <form onSubmit={register.mutate} className="d-flex flex-column scrollable_y scrollable-thin_y">
                <div className="form-group">                   
                    <label className="form-label text-dark regular">Name <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-profile"></i>
                        <input 
                            type="text"
                            placeholder="Enter Your Name" 
                            className="form-control"
                            value={name}
                            onChange={({target}) => handelNameValidation(target.value)}
                        />                       
                    </div>                    
                    {nameError && <span className="error-message">{nameError}</span>}
                </div>
                <div className="form-group">                   
                    <label className="form-label text-dark regular">Email <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-mail"></i>
                        <input 
                            type="text" 
                            placeholder="Enter Your Email "
                            className="form-control"
                            value={email}
                            onChange={({target}) => handelEmailValidation(target.value)}   
                        />                     
                    </div>                    
                    {emailError && <span className="error-message">{emailError}</span>}
                </div>
                <div className="form-group">
                    <label className="form-label text-dark regular">Phone Number <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-password"></i>
                        {/* <input
                            type="text"
                            placeholder="+ 91 9876543210"
                            className="form-control"/> */}
                        <PhoneInput
                            country={'us'}
                            value={rawPhoneNumber}
                            onChange={handelPhoneNumberChange}
                            placeholder="Enter Your Phone Number"
                            inputClass="form-control"
                            onBlur={handelPhoneNumberValidator}
                        />
                    </div>
                    {phoneError && <span className="error-message">{phoneError}</span>}
                </div>
                <div className="form-group">
                    <label className="form-label text-dark regular">Password <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-security"></i>
                        <input 
                            type={ viewPassword ? 'type' : 'password' }
                            placeholder="Enter Your Password"
                            className="form-control"
                            value={password}
                            onChange={({target}) => handelPasswordValidation(target.value)}
                        />
                        <button className="btn btn-neutral"  type="button">
                            <i 
                                className={viewPassword ? 'icon icon-password-mask' : 'icon icon-eye'}
                                onClick={() => setViewPassword(!viewPassword)}
                            ></i>
                        </button>
                    </div>
                    {passwordError && <span className="error-message">{passwordError}</span>}
                </div>
            
                <div className="form-group">
                    <label className="form-label text-dark regular">Confirm Password <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-security"></i>
                        <input 
                            type={ viewConfirmPassword ? 'type' : 'password' }
                            placeholder="Confirm Your Password" 
                            className="form-control"
                            value={confirm_password}
                            onChange={({target}) => handelConfirmPasswordValidation(target.value)}
                        />
                        <button className="btn btn-neutral"  type="button">
                            <i 
                            
                                className={viewConfirmPassword ? 'icon icon-password-mask' : 'icon icon-eye'}
                                onClick={() => setViewConfirmPassword(!viewConfirmPassword)}
                            ></i>
                        </button>
                    </div>
                    {confirmPasswordError && <span className="error-message">{confirmPasswordError}</span>}
                </div>
                <div className="form-group">
                    <label className="form-label text-dark regular">Website <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-website"></i>
                        <input
                            type="text"
                            placeholder="Website URL"
                            className="form-control"
                            value={website}
                            onChange={({target}) => handelWebsiteValidation(target.value)} 
                            />
                    </div>
                    {websiteError && <span className="error-message">{websiteError}</span>}
                </div>
            </form>
            <button type="submit" className="btn tbn-block btn-primary my-3" disabled = {isRegisterDisabled()}  onClick={register.mutate} >Sign Up</button>  
            <p className="privacy-text text-center">By signing up, you agree to our <a href={PRIVACY_URL} target="_blank" className="primary-link">'Privacy Policy'</a> <span className="text-dark">&amp;</span> <br/><a href={TERMS_URL} target="_blank" className="primary-link">'Terms of service'</a></p>
            <p className="privacy-text text-center mt-1 mb-5" >Already have an account? <a href="#" className="primary-link" onClick={(e) => {e.preventDefault(); history.push('/login')}}>Login to Your Account</a></p>              
        </div>
    </div>
    <PreLoginBanner />
   </div>
   </>

}

export default SignUp;